import React from 'react'
import Helmet from 'react-helmet'
import renderWidgets from '../../../lib/widget-renderer'
import CenterContent from '../../widgets/components/CenterContent'
import createMeta from '../../utils/meta-creator'
import LiveChat from '../LiveChat'
import { connect } from 'react-redux'
import { setGlobalNumber } from '../../state/phone-number/actions'

class Section extends React.PureComponent {
  componentDidMount() {
    this.props.setGlobalNumber({
      phoneNumber: this.props.calltracksNumber
    })
  }
  render() {
    const {
      layout,
      name,
      metaTitle,
      usedVehicles,
      latestArticles,
      makes,
      allModels,
      allBodyTypes,
      locations,
      liveChatProviderId
    } = this.props
    if (!layout || !layout.cols) return null
    return (
      <div>
        <Helmet title={`${metaTitle || name}`} meta={createMeta(this.props)} />
        <LiveChat providerId={liveChatProviderId} />
        {layout.cols.map((column) =>
          renderWidgets({
            widgets: column.widgetArea.widgets,
            usedVehicles,
            makes,
            allModels,
            allBodyTypes,
            latestArticles,
            locations,
            container: CenterContent,
            pageType: 'section'
          })
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  setGlobalNumber: (settings) => dispatch(setGlobalNumber(settings))
})

export default connect(null, mapDispatchToProps)(Section)
